<template :pageData="pageData">
	<div class="page-wrapper">
    <div class="header">
			<div class="title">macOS</div>
			<a href="https://github.com/xzhih/hackintosh-list" class="submit">Submit</a>
		</div>
		<div class="wrapper os-wrapper">
			<!-- <a class="os-card shadow" title="底噪文件库" href="https://files.zhih.me/macOS/">
				<div class="os-icon">
					<img class="fileszhih-icon" src="https://pic.zhih.me/blog/favicon.png" alt="底噪文件库">
				</div>
				<div class="os-detail">
					<div class="fileszhih-name">底噪文件库</div>
					<div class="fileszhih-name">镜像下载站</div>
				</div>
			</a> -->
			<a class="os-card shadow" v-for="(os, index) in pageData.OSimages" :key="index" target="_blank" :title="os.OS" :href="os.Link">
				<div class="os-icon">
					<img v-if="(os.OS.substr(0, 5) === '10.13')" v-lazy="'https://pic.zhih.me/hackintosh/OS-images/10.13.png'" :alt="os.OS">
					<img v-if="(os.OS.substr(0, 5) === '10.14')" v-lazy="'https://pic.zhih.me/hackintosh/OS-images/10.14.png'" :alt="os.OS">
					<img v-if="(os.OS.substr(0, 5) === '10.15')" v-lazy="'https://pic.zhih.me/hackintosh/OS-images/10.15.png'" :alt="os.OS">
				</div>
				<div class="os-detail">
					<div class="os-name">{{ os.OS }}</div>
					<li>{{ os.Version }}</li>
					<li>{{ os.Author }}</li>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'OSimages',
		props: ['pageData']
	}
</script>

<style src="../assets/style.css"></style>
